<div class="card">
  <div class="card-body">
    <ngx-spinner
      [name]="spinnerName"
      [fullScreen]="false"
      type="ball-clip-rotate-multiple"
      size="medium">
      <p style="color: white">Loading ...</p>
    </ngx-spinner>

    <div class="row">
      <div class="col-md-12">
        <h3>Netflix audience parameters</h3>
      </div>
    </div>
  </div>
</div>
